import { Scale } from '@antv/scale';
export { Scale };
//# sourceMappingURL=interface.js.map